import { absorber, coercionStub } from './absorber';

// The document is one giant capability object — only these two primitive snapshots
// qualify as live reads under the read-only criterion.
const DOCUMENT_DATA_FIELDS = new Set(['title', 'referrer']);

function readDocumentField(field: 'title' | 'referrer'): string {
  try {
    if (typeof document === 'undefined') return '';
    return document[field];
  } catch {
    return '';
  }
}

let cachedMirror: unknown = null;

export function getDocumentMirror(): unknown {
  if (cachedMirror) return cachedMirror;
  cachedMirror = new Proxy(
    {},
    {
      get(_target, prop) {
        const stub = coercionStub(prop);
        if (stub) return stub;
        if (typeof prop === 'string' && DOCUMENT_DATA_FIELDS.has(prop)) {
          return readDocumentField(prop as 'title' | 'referrer');
        }
        return absorber;
      },
      set() {
        return true;
      },
    },
  );
  return cachedMirror;
}
